<template>
  <div class="transactions">
    <p class="transactions__title">
      {{ $t('proposedTransactions.addTransaction') }}
    </p>
    <b-nav class="transactions__transaction-list">
      <b-nav-item
        @click="showTransactionModal('even purchase')"
        link-classes="transactions__transaction">
        {{ $t('proposedTransactions.evenPurchase') }}
      </b-nav-item>
      <b-nav-item
        @click="showTransactionModal('split purchase')"
        link-classes="transactions__transaction">
        {{ $t('proposedTransactions.splitPurchase') }}
      </b-nav-item>
      <b-nav-item
        @click="showTransactionModal('deposit')"
        link-classes="transactions__transaction">
        {{ $t('proposedTransactions.deposit') }}
      </b-nav-item>
      <b-nav-item
        v-if="user.gender"
        @click="showTransactionModal('i purchased them')"
        link-classes="transactions__transaction">
        {{ $t(`proposedTransactions.iBoughtThem_${user.gender || '_M'}`) }}
      </b-nav-item>
      <b-nav-item
        @click="showTransactionModal('they purchased me')"
        link-classes="transactions__transaction">
        {{ $t('proposedTransactions.theyBoughtMe') }}
      </b-nav-item>
      <b-nav-item
        v-if="user.gender"
        @click="showTransactionModal('i lent them')"
        link-classes="transactions__transaction">
        {{ $t(`proposedTransactions.iLentThem_${user.gender || '_M'}`) }}
      </b-nav-item>
      <b-nav-item
        @click="showTransactionModal('they lent me')"
        link-classes="transactions__transaction">
        {{ $t('proposedTransactions.theyLentMe') }}
      </b-nav-item>
      <b-nav-item
        @click="showTransactionModal('comment')"
        link-classes="transactions__transaction">
        {{ $t('proposedTransactions.comment') }}
      </b-nav-item>
    </b-nav>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  SET_CLONE_OPERATION_INFO,
  SET_OPERATION,
  SET_SPLIT_PURCHASE_INFO,
} from '@/store/operations/types';
import {
  SET_EVENT_SELECTED_CONTACTS,
  SET_FINAL_EVENT_SELECTED_CONTACTS,
} from '@/store/user/types';

export default {
  name: 'ProposedTransactions',
  data() {
    return {
      transaction: '',
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      event: (state) => state.events.event,
    }),
  },
  methods: {
    setTransactionParticipants() {
      const { contacts } = JSON.parse(JSON.stringify(this.$store.state.events.event));
      if (contacts) {
        const index = contacts
          .findIndex((contact) => this.$store.state.user.user.user === contact.uid);
        if (index !== -1) {
          contacts[index].full_name = this.$t('CP.me');
          contacts[index].uid = this.$store.state.user.user.user;
        }
        if (this.transaction === 'even purchase'
          || this.transaction === 'split purchase'
          || this.transaction === 'deposit') {
          this.$store.commit(SET_FINAL_EVENT_SELECTED_CONTACTS, contacts);
          this.$store.commit(SET_EVENT_SELECTED_CONTACTS, contacts);
        } else if (this.transaction === 'i purchased them') {
          // this.$store.commit(SET_FINAL_EVENT_SELECTED_CONTACTS, [contacts[index]]);
          // this.$store.commit(SET_EVENT_SELECTED_CONTACTS, [contacts[index]]);
          this.$store.commit(SET_FINAL_EVENT_SELECTED_CONTACTS, []);
          this.$store.commit(SET_EVENT_SELECTED_CONTACTS, []);
        } else if (this.transaction === 'they purchased me') {
          this.$store.commit(SET_FINAL_EVENT_SELECTED_CONTACTS,
            contacts.filter((contact) => contact.uid === this.user.user));
          this.$store.commit(SET_EVENT_SELECTED_CONTACTS,
            contacts.filter((contact) => contact.uid === this.user.user));
        }
      }
    },
    showTransactionModal(transaction) {
      this.transaction = transaction;
      this.$store.commit(SET_CLONE_OPERATION_INFO, null);
      this.$store.commit(SET_SPLIT_PURCHASE_INFO, {});
      this.$store.commit(SET_OPERATION, transaction);
      this.setTransactionParticipants();
      this.$bvModal.show('add-transaction');
    },
  },
};
</script>

<style lang="scss" scoped>
  .transactions {
    height: 130px;
    text-align: right;
    padding: 15px 30px 15px;
    border-top: 1px solid #E6ECF8;
  }

  .transactions__title {
    color: var(--text-main-color);
    opacity: 0.6;
    font-size: 14px;
    margin-right: 8px;
  }

  .transactions__transaction-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .transactions__transaction {
    padding: 3px 7px;
    background-color: var(--backgound-color);
    border-radius: 6px;
    font-size: 13px;
    margin: 0 8px 8px 0;
  }
  // @media screen and (min-width: $breakpoint-lg) {
    .transactions {
      padding: 15px 19px 15px;
    }
  // }
</style>
